<template>
  <view-wrapper
    name="Edit standard label"
    path="standardlabels"
    backText="Standard labels"
    :loading="loading"
    :loadingText="loadingText"
    saveText="Save"
    :saveFunc="saveStandardLabel"
  >
    <wrapper class="mb-5" :check-for-child-focused="true">
      <grafokett-input
        type="text"
        :editable="true"
        label-placeholder="Name"
        v-model="standardLabel.name"
      />
      <grafokett-input
        type="text"
        :editable="true"
        label-placeholder="Size info"
        v-model="standardLabel.sizeInfo"
      />
      <grafokett-input
        type="text"
        :editable="true"
        label-placeholder="Unit price"
        v-model="standardLabel.unitPrice"
      />
      <grafokett-input
        type="text"
        :editable="true"
        label-placeholder="Unit quantity"
        v-model="standardLabel.unitQuantity"
      />
      <grafokett-input
        type="text"
        :editable="true"
        label-placeholder="Min order quantity"
        v-model="standardLabel.minOrderQuantity"
      />
      <grafokett-input
        type="text"
        :editable="true"
        label-placeholder="Article number"
        v-model="standardLabel.articleNumber"
      />
      <span class="mb-1 text-xs font-bold text-highlight"
        >Standard Label Type</span
      >
      <drop-down
        class="w-full mb-4"
        placholder="Select Type"
        :value="{ name: standardLabel.type }"
        valueProperty="name"
        searchProp="name"
        :options="types"
        @input="standardLabel.type = $event.name"
      >
      </drop-down>

      <span class="mb-1 text-xs font-bold text-highlight">Source Label</span>
      <drop-down
        class="w-full"
        placeholder="Select label"
        :value="sourceLabel"
        valueProperty="name"
        searchProp="name"
        :options="labels"
        @input="setSourceLabel($event)"
      >
      </drop-down>
    </wrapper>

    <modal
      v-if="confirmDeleteOpen"
      @close="confirmDeleteOpen = !confirmDeleteOpen"
      type="warning"
    >
      <template slot="body">
        <h3>Are you sure?</h3>
        <p>This action cannot be reverted</p>
      </template>
      <template slot="buttons">
        <grafokett-button
          class="mb-2 button big primary white"
          @click="confirmDeleteOpen = !confirmDeleteOpen"
          >Cancel</grafokett-button
        >
        <grafokett-button
          class="mb-2 button big primary white"
          @click="deleteLabel()"
          >Delete</grafokett-button
        >
      </template>
    </modal>
  </view-wrapper>
</template>

<script>
import GrafokettInput from "../components/forms/Input";
import DropDown from "../components/forms/DropDown";
import GrafokettButton from "../components/forms/Button.vue";
import Modal from "../components/Modal";

export default {
  components: {
    Modal,
    GrafokettInput,
    GrafokettButton,
    DropDown
  },
  data() {
    return {
      headers: {
        name: "Name"
      },
      standardLabel: {
        name: "",
        unitPrice: "0",
        unitQuantity: "1",
        minOrderQuantity: "1",
        labelId: 0,
        type: "StandardLabel"
      },
      sourceLabel: null,
      loading: false,
      loadingText: "List of labels",
      warningText: "",
      disableCreateNewLabel: false,
      labelToDelete: null,
      confirmDeleteOpen: false,
      types: [{ name: "StandardLabel" }, { name: "TestLabel" }]
    };
  },
  computed: {
    allLabels() {
      return this.$store.getters["LABELS/LABELS"]
        .filter(l => !l.disabled)
        .map(l => {
          return {
            id: l.labelId,
            name: l.name,
            labelId: l.labelId,
            labelName: l.name,
            disabled: l.disabled
          };
        });
    },
    labels() {
      return this.allLabels.filter(l => !l.disabled);
    }
  },
  methods: {
    async getData() {
      await this.$store.dispatch("LABELS/GET_STANDARD_LABELS");
      await this.$store.dispatch("LABELS/GET_LABELS");

      const editStandardLabel = this.$store.getters[
        "LABELS/STANDARD_LABELS"
      ].find(sl => sl.id == this.$route.params.id);
      if (editStandardLabel) {
        this.standardLabel = {
          ...editStandardLabel
        };

        this.sourceLabel = this.$store.getters["LABELS/LABELS"].find(
          sl => sl.labelId == editStandardLabel.labelId
        );
      }
    },
    setSourceLabel(input) {
      this.sourceLabel = input;
      this.standardLabel.labelId = input.labelId;
    },
    async deleteLabel() {
      this.confirmDeleteOpen = false;
      this.loading = true;
      await this.$store.$api.delete(
        `/api/labels/standardlabels/${this.labelToDelete.parentId}`
      );
      this.labelToDelete = null;
      this.getData();
      this.loading = false;
    },
    openConfirmModal(labelToDelete) {
      this.confirmDeleteOpen = true;
      this.labelToDelete = labelToDelete;
    },
    async saveStandardLabel() {
      this.loading = true;
      const payload = {
        ...this.standardLabel
      };
      await this.$store.dispatch("LABELS/SAVE_STANDARD_LABEL", payload);
      this.loading = false;
      await this.$router.push("/standardlabels");
    }
  },
  async mounted() {
    this.loading = true;
    await this.getData();
    this.loading = false;
  }
};
</script>
